import { IFormValues } from './interfaces';

export const DEFAULT_VALUES: IFormValues = {
  title: '',
  value: '',
  is_tracked: false,
  active: false,
  days: [],
  hours: {
    start: '',
    end: '',
  },
  dont_use_on_holidays: false,
};
export const ALL_WEEK_DAYS = [1, 2, 3, 4, 5, 6, 7];
